class PolarizedCompareSlider extends HTMLElement {
  connectedCallback() {
    this.autoplayEnabled = this.dataset.autoplay !== 'false';
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const currentPosition = getComputedStyle(this).getPropertyValue('--position');
    this.base = parseFloat(currentPosition) || 50;

    this.setPosition(this.base);

    if (this.autoplayEnabled && !this.prefersReducedMotion) {
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.stopped = true;
  }

  setPosition(value) {
    const clamped = Math.min(100, Math.max(0, value));
    this.style.setProperty('--position', `${clamped}%`);
  }

  startAutoplay() {
    const amplitude = Math.max(0, Math.min(35, Math.min(this.base, 100 - this.base)));
    const period = 6000;
    const start = performance.now();

    const step = (now) => {
      if (this.stopped || !this.isConnected) return;

      const elapsed = now - start;
      const angle = (elapsed / period) * Math.PI * 2;
      const value = this.base + Math.sin(angle) * amplitude;

      this.setPosition(value);

      requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }
}

if (!customElements.get('polarized-compare-slider')) {
  customElements.define('polarized-compare-slider', PolarizedCompareSlider);
}
